<template>
  <div class="term-of-service">
    <BaseModal>
      <template v-slot:modalheader>
        <p class="title is-4">
          {{ $t("term_service.term_service_title") }}
        </p>
      </template>
      <template v-slot:modalbody>
        <p>
          {{ $t("term_service.term_service_paragraph") }}
        </p>
        <ol>
          <li v-html="$t('term_service.term_service_text_1')"></li>
          <li v-html="$t('term_service.term_service_text_2')"></li>
          <li v-html="$t('term_service.term_service_text_3')"></li>
          <li v-html="$t('term_service.term_service_text_4')"></li>
          <li v-html="$t('term_service.term_service_text_5')"></li>
          <li v-html="$t('term_service.term_service_text_6')"></li>
        </ol>
      </template>
      <template v-slot:modalfooter>
        <b-button
          outlined
          type="is-primary"
          :aria-label="$t('message.close_btn')"
          @click="$parent.close()"
        >
          {{ $t("message.close_btn") }}
        </b-button>
      </template>
    </BaseModal>
  </div>
</template>

<script>
import BaseModal from "@/components/base-components/BaseModal.vue";
export default {
  name: "TermOfServiceModal",
  components: {
    BaseModal
  }
};
</script>

<style></style>
